// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"DashBoardHeader__materialize-textarea___gnZBl","modal-2463794813":"DashBoardHeader__modal-2463794813___3I1ex","container":"DashBoardHeader__container___2LgLL","coachContainer":"DashBoardHeader__coachContainer___2Ggd4","urlPath":"DashBoardHeader__urlPath___3RM_T","currentUrl":"DashBoardHeader__currentUrl___2Lfrz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderWithTabs/DashBoardHeader.scss
// module id = 1496
// module chunks = 0